module.exports = __webpack_public_path__ + "media/guanya partida.6f017918.mp3";